import script from "./fault-order-list-wrap.vue?vue&type=script&lang=ts&setup=true"
export * from "./fault-order-list-wrap.vue?vue&type=script&lang=ts&setup=true"

import "./fault-order-list-wrap.vue?vue&type=style&index=0&id=6d91d9f0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d91d9f0"]])

export default __exports__